import axios from "axios";
import ShopService from "../services/shop-service";
import growl from "./growl";
import DeliveryDateService from "../checkout/delivery-date-service";
import OrderCalc from "../checkout/order-calc-service";
import DataStore from './data-store';
import Vue from 'vue';
import moment from "moment";
import { Order } from "../../types";
import _ from "lodash";

let reactive = Vue.observable({
	stuartMsg: '',
	stuartProcessing: false,
});

export default {
	checkAccessToken,
	createAccessToken,
	needsStuartJob,
	needZone,
	applyDeliveryFeeAsync,
	checkDropoffContactAsync,
	checkAddressAsync,
	checkDeliveryTimeAsync,
	getJobAsync,
	makeJob,
	// doCheckAsync,
	getLinkToJob,
	get stuartMsg() {
		return reactive.stuartMsg;
	},
	get stuartProcessing() {
		return reactive.stuartProcessing;
	}
};

function getLinkToJob(job_or_jobId, shop = null) {
	let sandbox = '';
	let job_id = null;
	if (shop) {
		job_id = job_or_jobId;
		if (shop.stuart_account && shop.stuart_account.account_type == 'sandbox') {
			sandbox = '.sandbox';
		}
	} else {
		job_id = job_or_jobId.id;
		if (job_or_jobId.deliveries[0].tracking_url.indexOf('sandbox') != -1) {
			sandbox = '.sandbox';
		}
	}
	return `https://dashboard${sandbox}.stuart.com/jobs/${job_id}`
}

// function doCheckAsync(msg, checkFnAsync) {
// 	reactive.stuartMsg = msg;
// 	reactive.stuartProcessing = true;
// 	DataStore.notifyAngularJs();
// 	return checkFnAsync()
// 		.then(() => reactive.stuartMsg = "")
// 		.catch(data => {
// 			let msg = (data && data.msg) || "";
// 			growl.error(msg);
// 			reactive.stuartMsg = msg;
// 			return Promise.reject({ msg });
// 		})
// 		.finally(() => {
// 			reactive.stuartProcessing = false;
// 			DataStore.notifyAngularJs();
// 		});
// }

function createAccessToken(stuart_account) {
	let config = getConfig(stuart_account, "/oauth/token");

	let payload = {
		client_id: stuart_account.api_client_id,
		client_secret: stuart_account.api_client_secret,
		scope: "api",
		grant_type: "client_credentials",
	};

	return axios
		.post(config.url, payload)
		.then(res => res.data)
		.catch(err => Promise.reject({ msg: err.response.data.error_description }))
		.finally(() => notifyAngularJs());
}

function getConfig(stuart_account, endpoint) {
	let stuart_url;
	if (stuart_account.account_type == "sandbox") {
		stuart_url = "https://api.sandbox.stuart.com";
	} else {
		stuart_url = "https://api.stuart.com";
	}
	return {
		url: stuart_url + endpoint,
		http_config: { headers: { Authorization: "Bearer " + stuart_account.access_token } },
	};
}

function applyDeliveryFeeAsync(order) {
	let stuart_account = order.shop.stuart_account;
	if (!stuart_account || !stuart_account.is_active || !stuart_account.use_stuart_fee) {
		order.stuart_ShippingFee = null;
		OrderCalc.recalcFees(order);
		return Promise.resolve(true);
	}
	let config = getConfig(stuart_account, "/v2/jobs/pricing");
	let p = Promise.resolve(true);
	if (!order.PickupTimeDate) {
		p = DeliveryDateService.getFirstPickupTimeDateAsync(order)
		// what if ptd is null ? the request will fail ! i cant allow that !
		.then(ptd => {
			order.PickupTimeDate = DeliveryDateService.getStringFromTimeDate(ptd);
			if (!order.PickupTimeDate) {
				// tomorrow at 10
				order.PickupTimeDate = moment().add(1,'day').hour(10).format('YYYY-MM-DD HH:mm:ss');
				return false;
			} else {
				return true;
			}
		});
	}
	return p.then((gotPtd) => {

	let job = makeJob(order, true);
	if (!gotPtd) {
		// now reset the time to force the user to choose a real time
		order.PickupTimeDate = null;
	}

	order.stuart_ShippingFee = NaN;
	return axios
		.post(config.url, job, config.http_config)
		.then(res => {
			if (res.data.amount) {
				if (res.data.currency == order.CurrencyCode) {
					order.stuart_ShippingFee = res.data.amount * (1 + stuart_account.vat_percent / 100);
					OrderCalc.recalcFees(order);
				} else {
					let msg = "Livraison non validée: la devise ne correspond pas";
					return Promise.reject({ msg });
				}
			} else {
				let msg = "Erreur lors du calcul du tarif de livraison";
				return Promise.reject({ msg });
			}
		})
		.catch(err => Promise.reject({ msg: extractErrorMessage(err.response.data, job) }))
		.finally(() => notifyAngularJs());
	});
}

function notifyAngularJs() {
	var $body = angular.element(document.body); // 1
	if ($body.scope()) {
		var $rootScope = $body.scope().$root; // 2
		$rootScope.$evalAsync();
	}
}

function checkDropoffContactAsync(order) {
	let job = makeJob(order);
	let config = getConfig(order.shop.stuart_account, "/v2/jobs/validate");

	return axios
		.post(config.url, job, config.http_config)
		.then(res => {
			// if (res.data.error) {
			// 	return Promise.reject({msg: extractErrorMessage(res.data, job) });
			// }
			if (res.data.valid) {
				order.info2.stuart_job_request = job;
				order.using_stuart_account_id = order.shop.stuart_account.id;
				return res.data.valid;
			} else {
				order.info2.stuart_job_request = null;
				return Promise.reject({ msg: "Livraison non validée" });
			}
		})
		.catch(err => Promise.reject({ msg: extractErrorMessage(err.response.data, job) }))
		.finally(() => notifyAngularJs());
}
function needsStuartJob(order) {
	return order.shop?.stuart_account?.is_active && order.SaleAreaId == ShopService.SALE_AREAS.DELIVERY;
}
function needZone(order) {
	if (!order.shop) {
		return false;
	}
	if (!order.shop.stuart_account?.is_active) {
		return true;
	}
	if (order.shop.stuart_account.limit_to_delivery_zones) {
		return true;
	}
	if (!order.shop.stuart_account.use_stuart_fee) {
		return true;
	}
	return false;
}

function getJobAsync(order) {
	if (!order.stuart_job_id || order.stuart_job_id == -1) {
		return Promise.resolve(null);
	}
	let config = getConfig(order.shop.stuart_account, "/v2/jobs/" + order.stuart_job_id);
	return axios
		.get(config.url, config.http_config)
		.then(res => res.data)
		.catch(err => Promise.reject(err.response.data))
		.finally(() => notifyAngularJs());
}

function makeJob(order: Order, dummy_contact = false) {
	let shop = order.shop;
	let clientAddress = order.address;
	let contact = {
		// firstname: "Martin",
		// lastname: "Pont",
		phone: shop.Tel,
		email: (shop.Email || '').split(';')[0],
		company: shop.DefaultName,
	};

	let shopAddress = `${shop.Address1} ${shop.Address2}, ${shop.Zip} ${shop.City}, ${shop.Country}`;
	let dropoff_address = `${clientAddress.Address}, ${clientAddress.Zip} ${clientAddress.City}, ${clientAddress.Country}`;
	let dropoff_comment: { [key: string]: string } = {};
	let address_complement = _.omit(clientAddress, ["Address", "Zip", "City", "Country", "Company", "AdrLabel"]);
	for (let i in address_complement) {
		if (address_complement[i] && _.isString(address_complement[i])) {
			dropoff_comment[i] = address_complement[i];
		}
	}
	if (order.info2.Commentaire) {
		if (dropoff_comment.Commentaire) {
			dropoff_comment.Commentaire = dropoff_comment.Commentaire + "; " + order.info2.Commentaire;
		} else {
			dropoff_comment.Commentaire = order.info2.Commentaire;
		}
	}
	let dropoff_comments = [];
	for (let i in dropoff_comment) {
		if (dropoff_comment[i]) {
			let str = i + ": " + dropoff_comment[i];
			dropoff_comments.push(str);
		}
	}
	let dropoff_contact;
	if (dummy_contact) {
		dropoff_contact = {
			company: "eatself test client",
			email: "test@email.com",
			phone: shop.Tel,
		};
	} else {
		dropoff_contact = getDropoffContact(order);
	}

	const job = {
		job: {
			transport_type: "bike",
			dropoff_at: order.PickupTimeDate + shop.timezone,
			pickups: [
				{
					address: shopAddress,
					contact: contact,
					comment: shop.stuart_account?.pickup_comment,
				},
			],
			dropoffs: [
				{
					// package_type: order.shop.stuart_account.package_type,
					// package_type: 'small',
					// package_description: "Red packet.",
					package_description: getOrderDescription(order),
					// client_reference:
					address: dropoff_address,
					// must be unique
					// client_reference: "12345678ABCDE",
					comment: dropoff_comments.join(", "),
					contact: dropoff_contact,
					partner_data: {
						integrator: 'Clyo Systems',
						marketplace: 'EatSelf',
					},
				},
			],
		},
	};
	return job;
}

function getOrderDescription(order) {
	let order_description = [];
	for (let i in order.oi) {
		let order_item = order.oi[i];
		let name = order_item.product.dn;
		if (order_item.qty == 1) {
			order_description.push(name);
		} else {
			order_description.push(order_item.qty + " x " + name);
		}
	}
	let order_description_str = order_description.join(", ");
	return order_description_str;
}

function getDropoffContact(order: Order) {
	let names = (order.info2.Nom || '').split(' ');
	return {
		firstname: names[0],
		lastname: names.slice(1).join(' '),
		phone: order.info2.Mobile,
		email: (order.client && order.client.Email) || "",
		company: (order.address && order.address.Company) || "",
	};
}

function extractErrorMessage(responseData, job = null) {
	let msg = responseData.message;
	if (responseData.error == "CANT_GEOCODE_ADDRESS") {
		msg = "Impossible de géolocaliser l'adresse";
	} else if (responseData.error == "OUT_OF_RANGE") {
		msg = "Adresse non couverte par le service de livraison";
	} else if (responseData.error == "PHONE_INVALID") {
		msg = "Téléphone invalide";
	} else if (responseData.error == "JOB_DISTANCE_NOT_ALLOWED") {
		msg = "La destination de livraison est trop loin";
		return "(Stuart) " + msg;
	} else if (responseData.error == "ADDRESS_INVALID") {
		msg = "L'adresse de destination n'est pas couverte"
	}
	for (let key in responseData.data) {
		let value = _.get(job, key, key.replace(/\./g, " "));
		let valueMsg = responseData.data[key][0];
		if (valueMsg == "can not schedule a dropoff at this time") {
			msg += ":" + value + "Impossible de livrer à cette heure";
		} else if (key == "job.dropoffs.contact_phone" && valueMsg == "is an invalid number") {
			msg += ": Le téléphone pour réception de la livraison est invalide";
		} else {
			msg += ": " + value + " " + valueMsg;
		}
		break;
	}
	return "(Stuart) " + msg;
}

function checkDeliveryTimeAsync(order) {
	let job = makeJob(order, true);
	let config = getConfig(order.shop.stuart_account, "/v2/jobs/validate");

	return axios
		.post(config.url, job, config.http_config)
		.then(res => {
			// if (res.data.error) {
			// 	return Promise.reject({msg: extractErrorMessage(res.data, job) });
			// }
			if (res.data.valid) {
				return res.data.valid;
			} else {
				return Promise.reject({ msg: "Livraison non validée" });
			}
		})
		.catch(err => Promise.reject({ msg: extractErrorMessage(err.response.data, job) }))
		.finally(() => notifyAngularJs());
}

function checkAddressAsync(order, clientAddress) {
	let dropoff_address = `${clientAddress.Address}, ${clientAddress.Zip} ${clientAddress.City}, ${clientAddress.Country}`;
	let phone = (order.shop.Tel && order.shop.Tel.split(" ").join("")) || "";
	let config = getConfig(
		order.shop.stuart_account,
		"/v2/addresses/validate?phone=" + phone + "&type=delivering&address=" + dropoff_address
	);

	return axios
		.get(config.url, config.http_config)
		.then(res => {
			// if (res.data.error) {
			// 	return Promise.reject({msg: extractErrorMessage(res.data)});
			// }
			if (res.data.success) {
				return res.data.success;
			} else {
				return Promise.reject({ msg: "Adresse non validée" });
			}
		})
		.catch(err => Promise.reject({ msg: extractErrorMessage(err.response.data) }))
		.finally(() => notifyAngularJs());
}

function checkAccessToken(stuart_account) {
	let config = getConfig(stuart_account, "/v2/areas/paris");
	return axios
		.get(config.url, config.http_config)
		.then(res => {
			// if (res.data.error) {
			// 	return Promise.reject({msg: extractErrorMessage(res.data)});
			// }
			return "ok";
		})
		.catch(err => Promise.reject({ msg: extractErrorMessage(err.response.data) }))
		.finally(() => notifyAngularJs());
}
